<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <div style="font-weight: bold;" [innerHTML]="data.text"></div>
  <br>
  <div *ngIf="data.showDataChanged || data.showOtherChanged || data.showNoChangesNeeded">
    <mat-radio-group [(ngModel)]="data.changedType">
      <div *ngIf="data.showNoChangesNeeded">
        <mat-radio-button value="noChangesNeeded">No changes needed</mat-radio-button><br><br>
      </div>
      <div *ngIf="data.showDataChanged">
        <mat-radio-button value="dataChanged">Data was changed</mat-radio-button><br><br>
      </div>
      <div *ngIf="data.showOtherChanged">
        <mat-radio-button value="otherChanged">Data already changed on another alert</mat-radio-button><br><br>
      </div>
    </mat-radio-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.showCancel" class="btn btn-light" mat-button mat-dialog-close>Cancel</button>
  <button class="btn btn-primary" [disabled]="!data.changedType && !data.isAcknowedge" mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</mat-dialog-actions>